import { FormKey } from '~/app/[:store]/order/[:idFromPlatform]/[:claimType]/return-summary/return-summary-action';
import { useReturnSummaryLoaderData } from '~/app/[:store]/order/[:idFromPlatform]/[:claimType]/return-summary/return-summary-loader';
import Badge from '~/components/Badge';
import RadioGroup, {
  ButtonOption,
} from '~/components/form-controls/RadioGroup';
import { ExchangeMethod, exchangeMethodLabel } from '~/utils/constants';
import ReturnSummaryDisclosure from './return-summary-disclosure';

function ExchangeMethodRadioGroup() {
  const {
    exchangeMethod: {
      offered: offeredExchangeMethods,
      selected: selectedExchangeMethod,
    },
  } = useReturnSummaryLoaderData();

  return (
    <RadioGroup label="Exchange Options" showLabel={false}>
      <div className="flex flex-col">
        {offeredExchangeMethods.map((method) => (
          <ButtonOption
            key={method.type}
            required
            name={FormKey.exchangeMethod}
            value={method.type}
            defaultChecked={selectedExchangeMethod === method.type}
            aria-labelledby={`method-${method.type}-label`}
            aria-describedby={`method-${method.type}-description`}
            className="items-start bg-white p-3 hover:bg-gray-50 [&>input]:mt-1"
          >
            <div className="flex flex-col gap-1 text-sm">
              <div
                id={`method-${method.type}-label`}
                className="flex items-center gap-2 font-medium text-gray-900"
              >
                {method.label}
                {method.type === ExchangeMethod.instant && (
                  <Badge variant="success">Fastest</Badge>
                )}
              </div>
              <p
                id={`method-${method.type}-description`}
                className="text-gray-500"
              >
                {method.description}
              </p>
            </div>
          </ButtonOption>
        ))}
      </div>
    </RadioGroup>
  );
}

export default function ExchangeSelection() {
  const loaderData = useReturnSummaryLoaderData();

  const {
    exchangeMethod: {
      selected: selectedExchangeMethod,
      offered: offeredMethods,
    },
  } = loaderData;

  const canInstantExchange = offeredMethods.some(
    (method) => method.type === ExchangeMethod.instant,
  );

  // standard exchange / no exchange required
  if (offeredMethods.length <= 1 || !canInstantExchange)
    return (
      <input
        data-testid="default-exchange-method"
        type="hidden"
        name={FormKey.exchangeMethod}
        value={ExchangeMethod.standard}
      />
    );

  return (
    <ReturnSummaryDisclosure
      label="Selections"
      value={
        selectedExchangeMethod ?
          exchangeMethodLabel[selectedExchangeMethod]
        : '1 Remaining'
      }
      defaultOpen
    >
      <ExchangeMethodRadioGroup />
    </ReturnSummaryDisclosure>
  );
}
